module.exports = __webpack_public_path__ + "static/media/B_food_2.6aeede0e.png";